module.exports = __webpack_public_path__ + "img/lets-go.dce1160b.png";